(function(){
     'use strict';

     angular
        .module('app')
        .factory('ProyectoService', ProyectoService);

    ProyectoService.$inject = ['$http'];

    function ProyectoService($http){

        var service= {
           getProyectos:getProyectos,
        };

        return service;


        function getProyectos(filtros,vm)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
           
            return $http.get('/ajax/getprojects', { params : { filtros : JSON.stringify(filtros),lang_id:lang_id,page:vm.page}  }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });


        }

         
    }
})();